// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1-swn","col":"styles_col__MAMWZ"};